import { cn } from "@/lib/utils/cn";

export function Toggle({
  checked, onChange, label, hint, disabled,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  hint?: string;
  disabled?: boolean;
}) {
  return (
    <label className={cn("flex items-start gap-3 cursor-pointer group", disabled && "opacity-50 cursor-not-allowed")}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={() => onChange(!checked)}
        className={cn(
          "mt-0.5 relative h-5 w-9 shrink-0 rounded-full transition-colors duration-150",
          checked ? "bg-accent" : "bg-ink-600 group-hover:bg-ink-500",
        )}
      >
        <span
          className={cn(
            "absolute top-0.5 h-4 w-4 rounded-full bg-ink-900 transition-transform duration-150",
            checked ? "translate-x-4" : "translate-x-0.5",
          )}
        />
      </button>
      <span className="flex flex-col gap-0.5">
        <span className="text-sm text-haze-100 leading-tight">{label}</span>
        {hint && <span className="text-xs text-haze-400 leading-relaxed">{hint}</span>}
      </span>
    </label>
  );
}

export function Checkbox({
  checked, onChange, label, hint, disabled,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  hint?: string;
  disabled?: boolean;
}) {
  return (
    <label className={cn("flex items-start gap-2.5 cursor-pointer", disabled && "opacity-50")}>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        className={cn(
          "mt-0.5 h-4 w-4 shrink-0 appearance-none rounded border transition-colors cursor-pointer",
          "border-ink-500 bg-ink-800",
          "checked:bg-accent checked:border-accent",
          "checked:bg-[url('data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 viewBox=%220 0 12 12%22%3E%3Cpath d=%22M2.5 6.5l2.5 2.5 4.5-5%22 stroke=%22%23000%22 stroke-width=%222%22 fill=%22none%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3C/svg%3E')] checked:bg-center checked:bg-no-repeat",
        )}
      />
      <span className="flex flex-col gap-0.5">
        <span className="text-sm text-haze-100 leading-tight">{label}</span>
        {hint && <span className="text-xs text-haze-400 leading-relaxed">{hint}</span>}
      </span>
    </label>
  );
}
